import { Component, PureComponent } from 'react'
import { I13nDiv } from '@vzmi/ec-react-i13n'
import { PROPOSAL_PHASE_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { Button } from '@vzmi/shp_shared_compo'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import styles from './ProductListingCompletion.css'
import _ from 'lodash'
import { unbindBeforeunload } from '../../Common/BeforeUnload'
import { HyperLink, AntdCheckbox } from '../../../Common/Form'
import { isNewProductProposal, isNewListingProposal } from '../../../../../lib/proposalHelper'
import { getDefaultTimezoneMoment } from '../../../../../lib/renderUtil'
import ItemIdClipBoard from '../../Common/ItemIdClipBoard/ItemIdClipBoard'
import ProposalCompletion from '../../Common/ProposalCompletion/ProposalCompletion'
import {
  AUTO_APPROVE_END_SEC,
  AUTO_APPROVE_DELAY_SEC
} from '../../../../constants/proposalTypes'
import withSupplierSharedLink from '../../../Common/HOC/withSupplierSharedLink'

const ProposalQueryLink = withSupplierSharedLink(
  ({
    children = '提案單查詢系統',
    linkName = 'scmProposalQuery',
    sharedLink,
    path = ''
  }) => {
    const link = sharedLink[linkName] || '#linkNotFound'

    unbindBeforeunload()

    return (
      <HyperLink
        className={styles.hyperlink}
        href={`${link}${path || ''}`}
      >
        {children}
      </HyperLink>
    )
  }
)

const ExpiredDate = props => {
  const { expiredDate } = props
  return (
    <span
      className={styles.expireDate}
      data-role='expired-date'
    >
      {expiredDate}
    </span>
  )
}

class KeepAddingListing extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      willCloneProposal: false
    }
  }

  handleCloneCheckbox = (e) => {
    const checked = _.get(e, 'target.checked', false)
    this.setState(() => ({
      willCloneProposal: checked
    }))
  }

  handleAddNewListing = () => {
    unbindBeforeunload()
    window.location.href = this.getUrlForAddingListing()
  }

  /** "繼續新增賣場"要去的 URL */
  getUrlForAddingListing = () => {
    const { willCloneProposal } = this.state
    const { id, proposalType } = this.props
    const { protocol, hostname, port } = window.location

    const newProposalPath = willCloneProposal
      ? `${PROPOSAL_PHASE_TYPE.CLONE}?id=${id}`
      : PROPOSAL_PHASE_TYPE.COMPOSE
    const portPostfix = _.isEmpty(port) ? '' : `:${port}`

    return `${protocol}//${hostname}${portPostfix}/proposal/${proposalType}/${newProposalPath}`
  }

  getTextContent = () => {
    const { proposalType } = this.props
    const proposalTypeLabel = isNewListingProposal(proposalType)
      ? '賣場'
      : '商品'

    return {
      cloneCheckboxLabel: `複製提案資訊到新${proposalTypeLabel}`,
      addNewBtnLabel: `繼續新增${proposalTypeLabel}`
    }
  }

  getI13nModelByLabel = (label) => {
    const { proposalType } = this.props

    const i13nModel = {
      category: proposalType,
      action: `${proposalType}_${PROPOSAL_PHASE_TYPE.COMPOSE}`,
      label
    }

    return i13nModel
  }

  render () {
    const { willCloneProposal } = this.state

    const {
      cloneCheckboxLabel,
      addNewBtnLabel
    } = this.getTextContent()

    const cloneCheckboxI13nModel = this.getI13nModelByLabel('check_clone')
    const addNewI13nModel = this.getI13nModelByLabel('compose_again')

    return (
      <div>
        <I13nDiv
          i13nModel={cloneCheckboxI13nModel}
        >
          <AntdCheckbox
            data-role='will-clone-proposal'
            className={styles.cloneCheckbox}
            label={cloneCheckboxLabel}
            onChange={this.handleCloneCheckbox}
            checked={willCloneProposal}
          />
        </I13nDiv>
        <I13nDiv
          i13nModel={addNewI13nModel}
        >
          <Button
            className={styles.composeNewProposal}
            size='large'
            onClick={this.handleAddNewListing}
            data-role='add-new-listing-btn'
          >
            {addNewBtnLabel}
          </Button>
        </I13nDiv>
      </div>
    )
  }
}

const withFetchItemIdTimer = WrappedComponent => {
  return (
    class extends PureComponent {
      constructor (props) {
        super(props)
        this.state = {
          elapsedSeconds: 0,
          targetSeconds: null,
          itemSpecs: null
        }
      }

      stopTimer = () => {
        clearInterval(this.timer)
      }

      getItemSpecsById = async () => {
        const { getItemSpecs, id } = this.props
        try {
          const itemSpecs = await getItemSpecs(id)
          if (!_.isNull(itemSpecs)) {
            this.stopTimer()
            this.setState(() => ({ itemSpecs }))
          }
        } catch (err) {
          console.log('getItemSpecs fail', err)
        }
      }

      tick = () => {
        const {
          elapsedSeconds,
          targetSeconds,
          itemSpecs
        } = this.state

        // 超過 AUTO_APPROVE_DELAY_TIME，開始嘗試 fetchItemSpecs
        if (elapsedSeconds >= AUTO_APPROVE_DELAY_SEC && _.isNull(itemSpecs)) {
          this.getItemSpecsById()
        }

        if (elapsedSeconds <= targetSeconds) {
          this.setState(() => ({ elapsedSeconds: elapsedSeconds + 1 }))
        } else {
          this.stopTimer()
        }
      }

      startTimerUntil = (targetSeconds) => {
        this.setState(
          { targetSeconds },
          () => {
            this.timer = setInterval(this.tick, 1000)
          })
      }

      componentDidMount () {
        const {
          isPM,
          proposalType,
          isOutrightPurchase
        } = this.props

        const isNewProduct = isNewProductProposal(proposalType)

        if (isNewProduct && (isPM || !isOutrightPurchase)) {
          this.startTimerUntil(AUTO_APPROVE_END_SEC)
        }
      }

      render () {
        const {
          elapsedSeconds,
          targetSeconds,
          itemSpecs
        } = this.state

        const allProps = _.merge({}, {
          ...this.props,
          elapsedSeconds,
          targetSeconds,
          itemSpecs
        })

        return (
          <WrappedComponent
            {...allProps}
          />
        )
      }
    }
  )
}

const ThresholdFreebieTips = ({ isThresholdFreebie }) => {
  return isThresholdFreebie
    ? (
      <p>
        綁定滿額禮活動，可至新增
        <ProposalQueryLink
          linkName={'scmHomepage'}
          path='Mvc/GiftWithPurchase/Step1'
        >
          購物車滿額禮活動提案
        </ProposalQueryLink>
        操作
      </p>
    )
    : null
}

export class ProductListingCompletion extends Component {
  static IMG_PROPOSAL_APPROVED = `${CDN}/img/img_proposal_product.svg`
  static IMG_PROPOSAL_PENDING_REVIEW = `${CDN}/img/img_proposal_success.svg`
  static IMG_PROPOSAL_WAITING = `${CDN}/supplier/img_proposal_waiting_1551782364929.svg`

  getProposalCompletionTitle = () => {
    const {
      isPM,
      title = null,
      proposalType = '',
      isOutrightPurchase = false
    } = this.props

    if (title) {
      return title
    }

    const isNewProduct = isNewProductProposal(proposalType)

    if (isNewProduct && (isPM || !isOutrightPurchase)) {
      const {
        elapsedSeconds,
        targetSeconds,
        itemSpecs
      } = this.props

      if (!_.isNull(itemSpecs)) {
        return '提案已經通過，商品新增成功'
      }
      if (elapsedSeconds <= targetSeconds) {
        const percentage = Math.floor(elapsedSeconds / targetSeconds * 100)
        return `提案審核中，請稍候(${percentage}%)`
      }
    }

    return '提案已送出'
  }

  getProposalCompletionSubTitle = () => {
    const { subTitle = null } = this.props
    return subTitle || '提案編號：'
  }

  getScmLinkBlock = () => {
    const {
      proposalType,
      isOutrightPurchase,
      expiredTs,
      elapsedSeconds,
      targetSeconds
    } = this.props

    const expiredDate = expiredTs
      ? getDefaultTimezoneMoment(expiredTs)
        .format('YYYY/MM/DD')
      : null

    const isNewProduct = isNewProductProposal(proposalType)
    const isUnderOrEqualTargetSeconds = elapsedSeconds <= targetSeconds
    const isNewProductAutoApproving = isNewProduct && !isOutrightPurchase && isUnderOrEqualTargetSeconds

    return (
      isNewProductAutoApproving
        ? (
          <p>
            提案正由雅虎資訊進行審核，請稍候審核結果
            <br />
            若需離開，可至
            <ProposalQueryLink />
            查詢進度。
          </p>
        )
        : (
          <p>
            提案將由雅虎資訊進行審核，預計於
            <ExpiredDate expiredDate={expiredDate} />
            前審核完畢
            <br />
            請留意審核狀態，查詢進度可至
            <ProposalQueryLink />
            查詢。
          </p>
        )
    )
  }

  getKeepAddingListingBlock = () => {
    const { proposalType, id } = this.props
    return (
      <KeepAddingListing
        id={id}
        proposalType={proposalType}
      />
    )
  }

  getItemIdClipBoard = () => {
    const { itemSpecs } = this.props
    const hasItemSpecs = !_.isNull(itemSpecs)
    if (hasItemSpecs) {
      const joinedItemId = itemSpecs
        .map(itemSpec => itemSpec.itemId)
        .join(',')

      return (
        <div className={styles.clipBoardBlock}>
          <ItemIdClipBoard
            joinedItemId={joinedItemId}
            itemSpecs={itemSpecs}
          />
        </div>
      )
    }

    return null
  }

  getProposalCompletionImg = () => {
    const {
      elapsedSeconds,
      targetSeconds,
      itemSpecs
    } = this.props

    const hasGottenItemSpecs = !_.isNull(itemSpecs)

    if (hasGottenItemSpecs) {
      return ProductListingCompletion.IMG_PROPOSAL_APPROVED
    }

    if (elapsedSeconds < targetSeconds) {
      return ProductListingCompletion.IMG_PROPOSAL_WAITING
    }

    return ProductListingCompletion.IMG_PROPOSAL_PENDING_REVIEW
  }

  render () {
    const { id: proposalId, proposalType = '' } = this.props
    return (
      <div
        data-role='product-listing-completion'
        className={styles.ProductListingCompletion}
      >

        <ProposalCompletion
          imgUrl={this.getProposalCompletionImg()}
          title={this.getProposalCompletionTitle()}
          subTitle={this.getProposalCompletionSubTitle()}
          proposalId={proposalId}
          proposalType={proposalType}
        >
          <div className={styles.completionContent}>

            { this.getScmLinkBlock() }
            <ThresholdFreebieTips {...this.props} />
            { this.getKeepAddingListingBlock() }
            { this.getItemIdClipBoard() }

          </div>
        </ProposalCompletion>

      </div>
    )
  }
}

export const ProductListingCompletionWithTimer = withFetchItemIdTimer(ProductListingCompletion)
